import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useSettings } from "@/contexts/SettingsContext";

/** Local editable copy of the settings singleton, with a save() that PUTs and refreshes everywhere. */
export const useSettingsForm = () => {
  const { settings } = useSettings();
  const qc = useQueryClient();
  const [form, setForm] = useState(settings);
  const [saving, setSaving] = useState(false);

  useEffect(() => setForm(settings), [settings]);

  const update = (name, value) => setForm((f) => ({ ...f, [name]: value }));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/settings", form);
      qc.invalidateQueries({ queryKey: ["settings"] });
      toast.success("Pengaturan disimpan.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Gagal menyimpan pengaturan.");
    } finally {
      setSaving(false);
    }
  };

  return { form, update, save, saving };
};
